import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const [userType, setUserType] = useState(null);

  const handleUserTypeSelection = (type) => {
    setUserType(type);
  };

  return (
    <section
      className="relative min-h-screen flex items-center justify-center text-white overflow-hidden"
      style={{
        backgroundImage: `url('/assets/images/background/home_bg.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Dark Overlay for better text visibility */}
      <div className="absolute inset-0 bg-black/70 z-0"></div>

      {/* Main Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {!userType ? (
          <div className="mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold mb-4 text-white">
              Shaping the Future of AI & Robotics — One Learner, One Organization at a Time
            </h2>
            <p className="text-gray-300 mb-8 text-lg">
              Choose your path to innovation:
            </p>

            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center max-w-2xl mx-auto">
              {/* Individual Learner */}
              <Link to="/individual-learning-new">
                <button
                  //onClick={() => handleUserTypeSelection('individual')}
                  className="group relative w-full sm:w-80 p-8 rounded-2xl bg-white/10 backdrop-blur-md border border-gray-500 hover:border-blue-400 transition-all duration-300 hover:shadow-lg"
                >
                  <div className="flex flex-col items-center space-y-4">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center shadow-md group-hover:shadow-xl transition-all duration-300">
                      <Icon name="User" size={32} color="white" />
                    </div>
                    <h3 className="text-xl font-semibold text-white">Individual Learner</h3>
                    <p className="text-gray-300 text-center">
                      Start your personal journey in AI, Robotics, and Coding
                    </p>
                    <div className="flex items-center space-x-2 text-blue-400">
                      <span className="text-sm font-medium">Start Your Journey</span>
                      <Icon name="ArrowRight" size={16} />
                    </div>
                  </div>
                </button>
              </Link>

              {/* Institution */}
              <Link to ="/contact-support">
                <button
                  //onClick={() => handleUserTypeSelection('institutional')}
                  className="group relative w-full sm:w-80 p-8 rounded-2xl bg-white/10 backdrop-blur-md border border-gray-500 hover:border-blue-400 transition-all duration-300 hover:shadow-lg"
                >
                  <div className="flex flex-col items-center space-y-4">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center shadow-md group-hover:shadow-xl transition-all duration-300">
                      <Icon name="Building2" size={32} color="white" />
                    </div>
                    <h3 className="text-xl font-semibold text-white">Organization</h3>
                    <p className="text-gray-300 text-center">
                      Transform your organization with cutting-edge training programs
                    </p>
                    <div className="flex items-center space-x-2 text-blue-400">
                      <span className="text-sm font-medium">Transform Your Organization</span>
                      <Icon name="ArrowRight" size={16} />
                    </div>
                  </div>
                </button>
              </Link>
            </div>
          </div>
        ) : (
          <div className="mb-12">
            {userType === 'individual' ? (
              <div className="max-w-4xl mx-auto">
                <div className="grid md:grid-cols-2 gap-8 mb-8">
                  <div className="bg-white/10 backdrop-blur-md p-6 rounded-lg">
                    <div className="flex items-center space-x-3 mb-4">
                      <Icon name="Users" size={24} className="text-green-400" />
                      <h3 className="text-lg font-semibold text-white">Join 100+ Learners</h3>
                    </div>
                    <p className="text-gray-300 mb-4">
                      Connect with passionate developers, AI enthusiasts, and robotics innovators from around the world.
                    </p>
                    {/* <div className="flex items-center space-x-4 text-sm">
                      <span className="text-green-400 font-medium">92% Job Placement Rate</span>
                      <span className="text-blue-400 font-medium">Next Cohort: Jan 2025</span>
                    </div> */}
                  </div>

                  <div className="bg-white/10 backdrop-blur-md p-6 rounded-lg">
                    <div className="flex items-center space-x-3 mb-4">
                      <Icon name="Trophy" size={24} className="text-yellow-400" />
                      <h3 className="text-lg font-semibold text-white">Real Success Stories</h3>
                    </div>
                    <p className="text-gray-300 mb-4">
                      "Looking back, it's incredible to see how far I've come: from zero coding experience to teaching at schools!"
                    </p>
                    <div className="flex items-center space-x-2">
                      <Image
                        src="/assets/images/avatars/neel_logo.jpeg"
                        alt="Neel Mehta"
                        className="w-12 h-12 rounded-full"
                      />
                      <span className="text-sm text-gray-300">Neel Mehta, Python Instructor</span>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link to="/individual-learning-new">
                    <Button
                      variant="default"
                      size="lg"
                      className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 rounded-lg"
                      iconName="Rocket"
                      iconPosition="left"
                    >
                      Start Learning Today
                    </Button>
                  </Link>
                  {/* <Button
                    variant="outline"
                    size="lg"
                    className="border border-gray-400 text-white px-8 py-4 rounded-lg"
                    iconName="Play"
                    iconPosition="left"
                  >
                    Watch Demo
                  </Button> */}
                </div>
              </div>
            ) : (
              <div className="max-w-4xl mx-auto">
                <div className="grid md:grid-cols-2 gap-8 mb-8">
                  <div className="bg-white/10 backdrop-blur-md p-6 rounded-lg">
                    <div className="flex items-center space-x-3 mb-4">
                      <Icon name="TrendingUp" size={24} className="text-green-400" />
                      <h3 className="text-lg font-semibold text-white">Proven ROI</h3>
                    </div>
                    <p className="text-gray-300 mb-4">
                      Organizations see an average 340% ROI within 12 months of implementing our training programs.
                    </p>
                    <div className="flex items-center space-x-4 text-sm">
                      <span className="text-green-400 font-medium">50+ Partner Companies</span>
                      <span className="text-blue-400 font-medium">Custom Lab Solutions</span>
                    </div>
                  </div>

                  <div className="bg-white/10 backdrop-blur-md p-6 rounded-lg">
                    <div className="flex items-center space-x-3 mb-4">
                      <Icon name="Award" size={24} className="text-yellow-400" />
                      <h3 className="text-lg font-semibold text-white">Enterprise Success</h3>
                    </div>
                    <p className="text-gray-300 mb-4">
                      "DCC transformed our workforce. 95% of our employees now confidently work with AI tools."
                    </p>
                    <div className="flex items-center space-x-2">
                      <Image
                        src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=32&h=32&fit=crop&crop=face"
                        alt="David Thompson"
                        className="w-8 h-8 rounded-full"
                      />
                      <span className="text-sm text-gray-300">David Thompson, CTO at TechCorp</span>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link to="/contact-support">
                    <Button
                      variant="default"
                      size="lg"
                      className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 rounded-lg"
                      iconName="Building2"
                      iconPosition="left"
                    >
                      Explore Solutions
                    </Button>
                  </Link>
                  <Link to ="/contact-support">
                    <Button
                      variant="outline"
                      size="lg"
                      className="border border-gray-400 text-white px-8 py-4 rounded-lg"
                      iconName="Calendar"
                      iconPosition="left"
                    >
                      Schedule Demo
                    </Button>
                  </Link>
                </div>
              </div>
            )}

            <button
              onClick={() => setUserType(null)}
              className="mt-6 text-gray-400 hover:text-white transition-colors duration-300 flex items-center space-x-2 mx-auto"
            >
              <Icon name="ArrowLeft" size={16} />
              <span className="text-sm">Back to selection</span>
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
